query SearchParameterGroups(
    $term: String!
) {
    searchParameterGroups(
        term: $term
    ) {
        id

        name(language: "en") {
            text
        }
    }
}
